import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/draftSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const CustomDateRanges = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.draft.rangeOptions);
  const selected = useSelector((state) => state.draft.selectedFilters.rangeOption);

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selected}
      includeFilter={false}
      onSelectChange={(data) => dispatch(actionCreators.updateCustomRange(data))}
    />
  );
};

export default CustomDateRanges;
